// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ShipmentsLogsTable.css */

/* Override grid container styles */
.ag-theme-alpine {
    height: 60vh;
    min-height: 0;
}

/* Custom row styles */
.custom-row {
    background-color: #f0f0f0;
}

/* Custom header styles */
.custom-header {
    background-color: #e0e0e0;
}

/* Custom cell styles */
.custom-cell {
    font-weight: bold;
}

.ag-body-horizontal-scroll-viewport{ /*Helps hide the x Scrollbar in table*/
    height: 0px !important;
      max-height: 0px !important;
      min-height: 0px !important;
  }

.ag-body-vertical-scroll-viewport{
    height: 0px !important;
      max-height: 0px !important;
      min-height: 0px !important;
}
.ag-body-vertical-scroll{
    height: 0px !important;
      max-height: 0px !important;
      min-height: 0px !important;
}
.ag-body-horizontal-scroll{
    height: 0px !important;
    max-height: 0px !important;
    min-height: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ShipmentsTable/ShipmentsLogsDrawer/ShipmentLogsTable/ShipmentsLogsTable.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B,mCAAmC;AACnC;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,iBAAiB;AACrB;;AAEA,qCAAqC,sCAAsC;IACvE,sBAAsB;MACpB,0BAA0B;MAC1B,0BAA0B;EAC9B;;AAEF;IACI,sBAAsB;MACpB,0BAA0B;MAC1B,0BAA0B;AAChC;AACA;IACI,sBAAsB;MACpB,0BAA0B;MAC1B,0BAA0B;AAChC;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;AAC9B","sourcesContent":["/* ShipmentsLogsTable.css */\n\n/* Override grid container styles */\n.ag-theme-alpine {\n    height: 60vh;\n    min-height: 0;\n}\n\n/* Custom row styles */\n.custom-row {\n    background-color: #f0f0f0;\n}\n\n/* Custom header styles */\n.custom-header {\n    background-color: #e0e0e0;\n}\n\n/* Custom cell styles */\n.custom-cell {\n    font-weight: bold;\n}\n\n.ag-body-horizontal-scroll-viewport{ /*Helps hide the x Scrollbar in table*/\n    height: 0px !important;\n      max-height: 0px !important;\n      min-height: 0px !important;\n  }\n\n.ag-body-vertical-scroll-viewport{\n    height: 0px !important;\n      max-height: 0px !important;\n      min-height: 0px !important;\n}\n.ag-body-vertical-scroll{\n    height: 0px !important;\n      max-height: 0px !important;\n      min-height: 0px !important;\n}\n.ag-body-horizontal-scroll{\n    height: 0px !important;\n    max-height: 0px !important;\n    min-height: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
